import { Component, OnInit, OnDestroy, Input, EventEmitter, Output } from '@angular/core';

import { DialogService } from 'primeng/dynamicdialog';

import { currency } from 'app/constants/currency.constants';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';
import { HTTPService, HelperService, CalculationService, DataService } from 'app/services';

import { find, isEqual } from 'lodash';
import { Subscription } from 'rxjs';
import { CatalogItemPricingDialogComponent } from './components/update-catalog-item-pricing-dialog/update-catalog-item-pricing-dialog.component';

@Component({
  selector: 'app-parts-pricing',
  templateUrl: './parts-pricing.component.html',
  styleUrls: ['./parts-pricing.component.scss'],
})
export class PartsPricingComponent implements OnInit, OnDestroy {
  @Input() isOpenAsDialog: boolean = false;
  @Input() selectedMatrix;
  @Input() isReadOnly: boolean = false;

  @Output() onMatrixChange = new EventEmitter<any>();
  validate: any = {};
  componentTitle: string = '';
  partPricings: any = [];
  pricingItem: any = {
    min: 0,
    max: '',
    markup: '',
    margin: '',
    desc: 0,
    salesPrice: 0,
    marginPercent: 0,
  };
  isReadOnlyPricing: boolean = false;
  isPricingUpdate: boolean = false;
  validateMsg: any = {};
  selectedPart: any = { value: '', label: '' };
  priceMatrices: any[] = [
    {
      name: '',
      type: 'part',
      items: [],
      default: false,
    },
  ];
  priceMatrix: any = {};
  defaultPriceMatrix: any = {};
  selectedPartMatrix: any = {};
  isUpdated: boolean = false;
  errors: any = {};
  focus: any = {};
  usd: string = currency.USD;
  isPricingMatricesManagement: boolean = false;
  isPricingManagementEnable: boolean = false;
  isAttributeBasedPricingEnable: boolean = false;
  isNewItemCategoriesEnable: boolean = false;
  isFirstLoad: boolean = false;
  dataListener: Subscription;
  isUpdatedCatalogPricingEnabled: boolean = false;
  isNewTireModalEnabled: boolean = false;
  isUseOnlinePricing: boolean = false;
  isNoChangeInPricingMatrix: boolean = false;
  constructor(
    private dataService: DataService,
    private httpService: HTTPService,
    private helperService: HelperService,
    private dialogService: DialogService,
    private calculationService: CalculationService,
  ) { }

  ngOnInit() {
    this.isReadOnlyPricing = this.isReadOnly;
    this.dataListener = this.dataService.getData().subscribe(({ data }) => {
      if (data) {
        if (data.key === 'company-appdata-updated') {
          this.isPricingManagementEnable = this.dataService.isPricingManagementEnable;
          this.isPricingMatricesManagement = this.dataService.isPricingMatricesManagement;
          this.isNewItemCategoriesEnable = this.dataService.isNewItemCategoriesEnable;
          this.isAttributeBasedPricingEnable = this.dataService.isAttributeBasedPricingEnable;
          this.isUpdatedCatalogPricingEnabled = this.dataService.isUpdatedCatalogPricingEnabled;
          this.isNewTireModalEnabled = this.dataService.isNewTireModalEnabled;
          this.isUseOnlinePricing = this.dataService.isUseOnlinePricing;

          this.dataListener.unsubscribe();
        }
      }
    });
    this.isPricingManagementEnable = this.dataService.isPricingManagementEnable;
    this.isPricingMatricesManagement = this.dataService.isPricingMatricesManagement;
    this.isNewItemCategoriesEnable = this.dataService.isNewItemCategoriesEnable;
    this.isAttributeBasedPricingEnable = this.dataService.isAttributeBasedPricingEnable;
    this.isNewTireModalEnabled = this.dataService.isNewTireModalEnabled;
    this.isUseOnlinePricing = this.dataService.isUseOnlinePricing;
    this.isUpdatedCatalogPricingEnabled = this.dataService.isUpdatedCatalogPricingEnabled;
    this.getPartsPricing();
  }

  /**  To get all pricing list of items (type = 'parts')  **/
  getPartsPricing(isPopulateDefault: boolean = true) {
    this.httpService.getPricings('part').then(
      (pricings: any[]) => {
        if (pricings && pricings.length) {
          pricings.forEach((pricing) => {
            pricing.items.forEach((item) => {
              item.defaultMarkup = item.markup;
              item.defaultMin = item.min;
              item.defaultMax = item.max;
            });
            if (pricing._id === this.priceMatrix._id) {
              this.priceMatrix.updateInProcess = pricing.updateInProcess;
              this.priceMatrix.version = pricing.version;
              this.priceMatrix.default = pricing?.default;
              this.priceMatrix.items.forEach((item) => {
                item.defaultMarkup = item.markup;
              });
            }
          });
          this.priceMatrices = pricings;
          if (this.isOpenAsDialog) {
            const pricingMatrix = this.priceMatrices.find((element) => (element.name === this.selectedMatrix.name || element.name === this.selectedMatrix?.matrixName));
            if (pricingMatrix && pricingMatrix._id) {
              this.populatePricingMatrix(pricingMatrix, isPopulateDefault);
            }
          } else {
            if (isPopulateDefault) {
              const defaultPricingMatrix = find(this.priceMatrices, {
                default: true,
              });

              if (defaultPricingMatrix && defaultPricingMatrix._id) {
                this.populatePricingMatrix(defaultPricingMatrix, isPopulateDefault);
              }
            } else {
              this.populatePricingMatrix(this.priceMatrix, isPopulateDefault);
            }
          }
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  populatePricingMatrix(pricing: any, isPopulateDefault?: boolean) {
    this.isPricingUpdate = !!pricing._id;
    this.priceMatrix = this.helperService.deepCopy(pricing);
    if (!this.isOpenAsDialog && this.isFirstLoad) {
      this.defaultPriceMatrix = this.helperService.deepCopy(this.priceMatrix);
      this.isFirstLoad = true;
    }
    isPopulateDefault ? this.addPricingItemToMatrix() : null;
  }

  addPricingItemToMatrix() {
    const pricingItem = { ...this.pricingItem };

    if (this.priceMatrix && this.priceMatrix.items && this.priceMatrix.items.length) {
      const lastItem = [...this.priceMatrix.items].pop();
      const minPrice = this.calculationService.roundOff(lastItem.max);
      pricingItem.min = this.calculationService.roundOff(minPrice + 0.01);
      this.priceMatrix.items.push(pricingItem);
    } else {
      this.priceMatrix.items = [pricingItem];
    }
  }

  handleChange(name: string, value: any) {
    this.priceMatrix[name] = value;
    this.checkForChanges();
  }

  handleDeleteItem(index: number) {
    const { items } = this.priceMatrix;

    if (items.length === 1) {
      this.priceMatrix.items = [];
      this.addPricingItemToMatrix();
    } else if (index === 0) {
      this.priceMatrix.items.splice(index, 1);
      this.priceMatrix.items[index].min = 0;
    } else {
      const [item] = this.priceMatrix.items.splice(index, 1);
      this.priceMatrix.items[index - 1].max = item.max;
    }

    this.checkForChanges();
  }

  handleBlur({ index, name }) {
    /** Adding new pricing line if all line are filled */
    if (index === this.priceMatrix.items.length - 1) {
      const lastItem = [...this.priceMatrix.items].pop();

      if (lastItem.max && lastItem.markup) {
        if (lastItem.max > lastItem.min) {
          this.addPricingItemToMatrix();
        } else if (name === 'max') {
          this.errors[index] = {
            max: 'Upper limit must be greater then lower limit',
          };
        }
      }
      /** Update the lower limit of next item if max has changed */
    } else if (name === 'max') {
      const nextLowerLimit = Number(this.priceMatrix.items[index].max) + 0.01;
      this.priceMatrix.items[index + 1].min = this.calculationService.roundOff(nextLowerLimit);
    }

    this.checkForChanges();
  }

  /**  This funciton calls when user selects any pricing template from dropdown  **/
  handleDropdownSelect(partMatrix: any) {
    this.populatePricingMatrix(partMatrix, true);
    this.checkForChanges();
  }

  checkForChanges() {
    const pricing = this.helperService.deepCopy(this.priceMatrix);
    const { max, markup, margin } = [...pricing.items].pop();

    if (!max && !markup && !margin) {
      pricing.items.pop();
    }

    this.isUpdated = !isEqual(this.defaultPriceMatrix, pricing);
  }

  handleConfirmDeletePricing() {
    // Fix for 18839: The commented statement below is unclear. It was already discussed with Zubair, who added this condition.
    // if (this.isPricingManagementEnable && this.isAttributeBasedPricingEnable && this.isNewItemCategoriesEnable) return;
    if (this.isPricingManagementEnable && !this.isPricingMatricesManagement || this.isReadOnlyPricing) return;

    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: `Delete ${this.priceMatrix.name}`,
        message: `Are you sure you want to delete this pricing?`,
        button: {
          success: { title: 'Delete' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess }) => {
      if (isSuccess) {
        this.deletePricing();
      }
      onClose.unsubscribe();
    });
  }

  /* To delete service by _id  */
  deletePricing() {
    if (!this.priceMatrix._id) {
      return;
    }

    this.httpService.removePricing(this.priceMatrix._id, 'part').then(
      (res) => {
        this.helperService.showToaster('success', 'Successfully deleted');
        this.getPartsPricing();
        this.createNewPricing();
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  createNewPricing() {
    this.priceMatrix = {
      name: '',
      type: 'part',
      items: [],
      default: false,
    };
    this.isPricingUpdate = false;
    this.addPricingItemToMatrix();
    this.checkForChanges();
  }

  setDefault(pricing: any) {
    if (!pricing._id) {
      return;
    }

    this.httpService.setDefaultPartPricing(pricing._id).then(
      (res) => {
        this.getPartsPricing(false);
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  /** Create part matrix */
  createPartPricing() {
    const pricing = this.helperService.deepCopy(this.priceMatrix);
    pricing.isUseOnlinePricing = this.isUseOnlinePricing;

    if (pricing.items && pricing.items.length) {
      pricing.items = pricing.items.filter(({ max, markup }) => max && markup);
    } else {
      pricing.items = [];
    }

    this.httpService.createPricings('part', pricing).then(
      (res: any) => {
        this.getPartsPricing(false);
        this.priceMatrix._id = res._id;
        if (this.isOpenAsDialog) this.onMatrixChange.emit({ data: this.priceMatrix, isNewPricingAdded: true });
        if (pricing.items.length) {
          this.helperService.showToaster('success', 'Part Pricing Created');
        } else if (pricing.isUseOnlinePricing || !pricing.isUseOnlinePricing) {
          this.helperService.showToaster('success', 'Part Pricing updated');
        }
        this.dataService.isUseOnlinePricing = this.isUseOnlinePricing || false;
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  /** Update part matrix */
  updatePartPricing() {
    if (this.isOpenAsDialog) this.onMatrixChange.emit({ data: this.priceMatrix });
    const pricing = this.helperService.deepCopy(this.priceMatrix);
    pricing.isUseOnlinePricing = this.isUseOnlinePricing;

    if (pricing.items && pricing.items.length) {
      pricing.items = pricing.items.filter(({ max, markup }) => max && markup);
    } else {
      pricing.items = [];
    }

    if (this.priceMatrix && this.priceMatrix.items) {
      this.priceMatrix.items.forEach((item) => {
        if ((item.markup && item.defaultMarkup !== Number(item.markup)) || (item.min && item.defaultMin !== Number(item.min)) || (item.max && item.defaultMax !== Number(item.max))) {
          this.isNoChangeInPricingMatrix = true;
        }
      });
    }

    this.httpService.UpdatePricings('part', pricing).then(
      (res: any) => {
        if (res.isUpdatePriceMatrix && this.isUpdatedCatalogPricingEnabled && this.isNoChangeInPricingMatrix) {
          this.priceMatrix.updateSyncItems = false;
          this.openCatalogPricingDialog(this.priceMatrix);
        }
        this.isNoChangeInPricingMatrix = false;
        this.getPartsPricing(false);
        if (pricing.items.length) {
          this.helperService.showToaster('success', 'Part Pricing Updated');
        }
        this.dataService.isUseOnlinePricing = this.isUseOnlinePricing || false;
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  /** Validating matrix */
  validation() {
    let isValid = true;
    if (this.priceMatrix && this.priceMatrix.items) {
      const { max, markup } = [...this.priceMatrix.items].pop();

      const items = [...this.priceMatrix.items];
      if (!max && !markup) {
        items.pop();
      }

      /** Validating Name */
      if (!this.priceMatrix.name) {
        this.errors.name = 'Title is required';
        isValid = false;
      } else {
        this.errors.name = '';
        isValid = true;
      }

      if (items && items.length) {
        items.forEach((item: any, index: number) => {
          this.errors[index] = {};
          /** Validating empty fields */
          this.errors[index] = {
            max: item.max ? '' : 'Price required',
            markup: item.markup ? '' : 'Markup required',
          };

          if (!item.max || !item.markup) {
            isValid = false;
          }

          if (item.min && item.max && item.min > item.max) {
            this.errors[index].max = 'Upper limit must be greater than lower limit';
            isValid = false;
          }
        });
      }
    }

    return isValid;
  }

  /** Showing confirmation model to save data */
  handleSaveChange() {
    if (!this.validation()) {
      return;
    }

    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: `Save changes`,
        message: `Are you sure you want to save these changes?`,
        button: {
          success: { title: 'Save' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess }) => {
      if (isSuccess) {
        if (this.priceMatrix._id) {
          this.updatePartPricing();
        } else {
          this.createPartPricing();
        }
      }
      onClose.unsubscribe();
    });
  }

  /** Showing confirmation modal to discard data */
  handleDiscardChange() {
    if (!this.isUpdated) {
      if (this.isOpenAsDialog) this.onMatrixChange.emit({ data: this.priceMatrix, isCancel: true });
      return;
    }
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: `Discard changes`,
        message: `The price matrix changes will be permanently discarded.`,
        button: {
          success: { title: 'Discard' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess }) => {
      if (isSuccess) {
        this.priceMatrix = this.helperService.deepCopy(this.defaultPriceMatrix);
        this.addPricingItemToMatrix();
        if (this.isOpenAsDialog) this.onMatrixChange.emit({ data: this.priceMatrix, isCancel: true });
      }
      onClose.unsubscribe();
    });
  }

  resyncCatalogPricing() {
    this.priceMatrix.updateSyncItems = true;
    this.openCatalogPricingDialog(this.priceMatrix);
  }

  openCatalogPricingDialog = (pricingMatrix) => {
    const ref = this.dialogService.open(CatalogItemPricingDialogComponent, {
      width: '1200px',
      styleClass: 'add-dialog catalog-pricing-dialog',
      showHeader: false,
      data: {
        pricingMatrix: pricingMatrix,
      },
    });
    const onClose = ref.onClose.subscribe(({ isSuccess }) => {
      if (isSuccess === true) {
        this.getPartsPricing(false);
      }
      onClose.unsubscribe();
    });
  };
  handleChangeCatelog(name: string, value: any) {
    this.isUpdated = true;
    this.isUseOnlinePricing = value;
  }

  ngOnDestroy(): void {
    this.dataListener.unsubscribe();
  }
}
